import React from 'react';
import { motion } from 'framer-motion';

const charities = [
  {
    name: "St. Jude Children's Research Hospital",
    description: "Fighting childhood cancer and pediatric diseases",
    logo: "https://www.stjude.org/etc/designs/stjude/primaryLogo.svg",
  },
  {
    name: "Feeding America",
    description: "Ending hunger in communities nationwide",
    logo: "https://www.feedingamerica.org/themes/fa_theme/images/logo-new-tagline.svg",
  },
  {
    name: "Wounded Warrior Project",
    description: "Honoring and empowering wounded veterans",
    logo: "https://www.woundedwarriorproject.org/themes/custom/wwp/logo.svg",
  },
  {
    name: "Disabled American Veterans",
    description: "Advocating for veteran benefits and support",
    logo: "https://www.dav.org/wp-content/themes/flavor/flavor/assets/images/logo.png",
  },
];

const CharitiesSection = () => {
  return (
    <section id="partners" className="py-24 bg-white" data-testid="charities-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1E3A8A] mb-4">
            — Our Partners —
          </p>
          <h2 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight mb-4">
            Making a Difference{' '}
            <span className="text-[#B8860B]">Together</span>
          </h2>
          <p className="text-lg text-slate-600 font-light max-w-2xl mx-auto">
            We proudly support respected national organizations making a difference every day.
          </p>
        </motion.div>

        {/* Charity Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {charities.map((charity, idx) => (
            <motion.div
              key={charity.name}
              className="bg-white border border-slate-200 rounded-2xl p-6 text-center hover:shadow-lg hover:border-[#1E3A8A]/30 transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              data-testid={`charity-card-${idx}`}
            >
              <div className="h-24 flex items-center justify-center mb-6">
                <img
                  src={charity.logo}
                  alt={charity.name}
                  className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden items-center justify-center text-3xl font-serif text-[#1E3A8A]">
                  {charity.name.charAt(0)}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-slate-800 mb-2 font-serif">
                {charity.name}
              </h3>
              <p className="text-sm text-slate-500">
                {charity.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CharitiesSection;
